import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["project", "photos"]

  connect() {
    this.select()
  }

  select() {
    this.photosTargets.forEach((photos) => {
      photos.hidden = photos.dataset.projectId !== this.projectTarget.value
    })
  }
}
